export const ACCOUNT_SECTIONS = {
  company_information: "company_information",
  company_logo: "company_logo",
  billing_information: "billing_information",
  business_address: "business_address",
  ship_from_address: "ship_from_address",
  deposits_and_disclaimers: "deposits_and_disclaimers",
  fabricator_account_settings: "fabricator_account_settings",
  analytics: "analytics",
  pingWidget: "pingWidget",
  bathroom_subscription: "bathroom_subscription",
  kitchen_subscription: "kitchen_subscription",
  fireplace_subscription: "fireplace_subscription",
  laundryroom_subscription: "laundryroom_subscription",
  docusign_and_finger_signature: "docusign_and_finger_signature",
  general_settings: "general_settings",
  bathroom_settings: "bathroom_settings",
  kitchen_settings: "kitchen_settings",
  fireplace_settings: "fireplace_settings",
  laundryroom_settings: "laundryroom_settings",
  customer_additional_info: "customer_additional_info",
  receipt_settings: "receipt_settings",
}
